module.exports = __webpack_public_path__ + "img/blocEnergizer.6645e3db.png";